import { __assign, __awaiter, __generator } from "tslib";
import { Status } from '@amplitude/types';
import { setupDefaultTransport } from '../transports';
import { DEFAULT_OPTIONS } from '../constants';
var BaseRetryHandler = /** @class */ (function () {
    function BaseRetryHandler(apiKey, options) {
        if (options === void 0) { options = {}; }
        var _a;
        this._apiKey = apiKey;
        this._options = __assign(__assign({}, DEFAULT_OPTIONS), options);
        this._transport = (_a = this._options.transportClass) !== null && _a !== void 0 ? _a : setupDefaultTransport(this._options);
    }
    /**
     * @inheritDoc
     */
    BaseRetryHandler.prototype.sendEventsWithRetry = function (events) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        response = { status: Status.Unknown, statusCode: 0 };
                        return [4 /*yield*/, this._transport.sendPayload(this._getPayload(events))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    BaseRetryHandler.prototype._getPayloadOptions = function () {
        if (typeof this._options.minIdLength === 'number') {
            return {
                options: {
                    min_id_length: this._options.minIdLength,
                },
            };
        }
        return {};
    };
    BaseRetryHandler.prototype._getPayload = function (events) {
        return __assign({ api_key: this._apiKey, events: events }, this._getPayloadOptions());
    };
    return BaseRetryHandler;
}());
export { BaseRetryHandler };
//# sourceMappingURL=baseRetry.js.map